import { Component, OnInit } from '@angular/core';
import { TableComponent } from '../../../shared/component/table/table.component';
import { AgGridTableService } from '../../../shared/services/ag-grid.service';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { ToastService } from '../../../shared/services/toast.service';
import { Router } from '@angular/router';
import { ConnectionService } from '../../../connection.service';

@Component({
  selector: 'app-bulk-action',
  imports: [TableComponent],
  templateUrl: './bulk-action.component.html',
  styleUrl: './bulk-action.component.scss'
})
export class BulkActionComponent implements OnInit {
header: string;
  constructor(private aggrid:AgGridTableService,private apiService: ApiCallsService,private ConnectionService: ConnectionService,private router: Router,private toast : ToastService) { }
  ngOnInit(): void {
    this.getbulkTable()
  }

  getbulkTable(){
    this.apiService.bulkaction().subscribe(response=>{
      console.log(response.Data);
      const responsenew = this.formatApiResponse(response.Data)
      console.log(responsenew);

      this.aggrid.processTableData(responsenew)
      
    })
  }



  formatApiResponse(rawList: any[]): any {
  // Handle empty or invalid list
  if (!Array.isArray(rawList) || rawList.length === 0) {
    return {
      Status: "Failed",
      Message: "No Data Found",
      Data: { list: [], total: 0, header: [] },
      StatusCode: 204
    };
  }

  const sample = rawList[0] ?? {};

  // Build header array dynamically
  const header = Object.keys(sample)
    .filter(key => key && key.toLowerCase() !== '_id' && key.toLowerCase() !== 'id')
    .map(key => ({
      name: this.formatHeader(key),
      key,
      filter: true,
      show: true,
      click: true
    }));

  // Return final JSON response
  return {
    Status: "Success",
    Message: "Success",
    Data: {
      list: rawList,
      total: rawList.length,
      header: header
    },
    StatusCode: 200
  };
}



private formatHeader(key: any): string {
  if (typeof key !== 'string') {
    key = String(key ?? ''); // convert null/undefined/number to string safely
  }

  return key
    .replace(/^_+/, '')                // remove leading underscores
    .replace(/_/g, ' ')                // replace underscores with spaces
    .replace(/\b\w/g, (c:any) => c.toUpperCase()); // capitalize each word
}


}
